import numeral from 'numeral';

const FormatUtil = {

    numValueFormatter1(params) {
        if (params.value === null || params.value === undefined || isNaN(params.value)) return null;
        var number = params.value;
        var formatted = numeral(number).format('0,0.0');
        return formatted === 'NaN' ? null : formatted;
    },

    numValueFormatter2(params) {
        if (params.value === null || params.value === undefined || isNaN(params.value)) return null;
        var number = params.value;
        var formatted = numeral(number).format('0,0.00');
        return formatted === 'NaN' ? null : formatted;
    },

    percentValueFormatter1(params) {
        if (params.value === null || params.value === undefined || isNaN(params.value)) return null;
        var number = params.value;
        var formatted = numeral(number).format('0,0.00');
        return formatted === 'NaN' ? null : formatted + '%';
    },

    percentValueFormatter2(params) {
        if (params.value === null || params.value === undefined || isNaN(params.value)) return null;
        var number = params.value * 100;
        var formatted = numeral(number).format('0,0.00');
        return formatted === 'NaN' ? null : formatted + '%';
    },

    percentValueFormatter3(params) {
        if (params.value === null || params.value === undefined || isNaN(params.value)) return null;
        var number = params.value * 100;
        var formatted = numeral(number).format('0,0.000');
        return formatted === 'NaN' ? null : formatted + '%';
    }

}


export default FormatUtil;
